import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SipMonthlyDonorCountComponent } from './sip-monthly-donor-count.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [SipMonthlyDonorCountComponent],
  exports: [SipMonthlyDonorCountComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SipMonthlyDonorCountModule { }
